import React, { useCallback } from "react";
import { Theme } from "interfaces/theme";
import * as S from "./styles";

interface ISwitchMode {
  onSwitch: Function;
  mode: Theme;
}
const SwitchMode: React.FC<ISwitchMode> = ({ onSwitch, mode }) => {
  const switchHandle = useCallback(() => {
    const nextMode = mode === "light" ? "dark" : "light";
    onSwitch(nextMode);
  }, [mode, onSwitch]);

  return (
    <S.Container mode={mode}>
      <S.Button onClick={switchHandle}>
        <span />
        {mode === "light" ? "Light mode" : "Dark mode"}
      </S.Button>
    </S.Container>
  );
};

export default SwitchMode;
